export default __webpack_public_path__ + "static/presentation-60bca804cc463ef0cadf4ac23b1b0c3d.pdf";